import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import useLocales from 'hooks/useLocales';
import Navbar from 'components/Navbar';
import Image from 'components/image/Image';
import Footer from 'components/Footer/Index';
import Popup from 'components/shared/Popups/Popup/Index';
import AvatarPopup from 'components/shared/Popups/Avatar/Index';
import ProfileSettings from 'components/shared/Popups/Settings/Profile/Index';
import { CANDIDATE_DEFAULT_ROUTE } from 'core/constants/candidateRoutes';
import { COMPANY_DEFAULT_ROUTE } from 'core/constants/companyRoutes';
import { Role } from 'core/enum/role';
import { IMe } from 'core/interface/me';
import { AuthService } from 'services/auth/auth';

import './Index.scss';

const isCompanyRole = (role?: string): boolean =>
  role === 'company' || role === Role.RECRUITER || role === Role.ADMIN;

const AccountSettings: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useLocales();
  const me = useSelector((state: IMe) => state.user).user;
  const [avatarEditModal, setAvatarEditModal] = useState(false);

  const handleBack = () => {
    navigate(isCompanyRole(me?.role) ? COMPANY_DEFAULT_ROUTE : CANDIDATE_DEFAULT_ROUTE);
  };

  const handleAfterSave = () => {
    AuthService.getAccount();
  };

  const openAvatarModal = () => {
    setAvatarEditModal((prev) => !prev);
  };

  return (
    <div className="account-settings-page">
      <Navbar />
      <div className="account-settings-page__content">
        <div className="navigation_section">
          <div className="back_button skillio-back-button" onClick={handleBack}>
            <Image name="arrow-left.svg" />
            {t('Back')}
          </div>
        </div>
        <div className="main_section">
          <div className="account-settings-page__card">
            <div className="account-settings-page__header">
              <h1 className="account-settings-page__title">{t('settings')}</h1>
            </div>
            <ProfileSettings
              handleClosePopup={handleAfterSave}
              openAvatarModal={openAvatarModal}
            />
          </div>
        </div>
      </div>
      {avatarEditModal && (
        <Popup onClose={openAvatarModal} title={t('Edit Your Profile Image')}>
          <AvatarPopup id={me.id} onPopupClose={openAvatarModal} t={t} />
        </Popup>
      )}
      <Footer />
    </div>
  );
};

export default AccountSettings;
